<template>
  <BHLink
    class="burger-link"
    :class="linkClass"
    :href="link.link"
    :style="`--bg-color: ${link.color_picker}; --text-color: ${link.color_text}`"
    colorless
    @click="$emit('click-menu-item', { link })"
  >
    <span
      class="burger-link__title"
      v-html="link.title"
    />
  </BHLink>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BHLink from '~/components/BHLink.vue';
  import { removeBurninghutFromUrl } from '~/utils/link';
  import type { ILink } from '~/components/ArrowMenu/ArrowMenu';

  export default defineNuxtComponent({
    name: 'BurgerLink',
    components: {
      BHLink,
    },

    props: {
      link: {
        type: Object as PropType<ILink>,
        required: true,
      },
    },

    emits: ['click-menu-item'],

    computed: {
      cssVariables(): string {
        return `
        --bg-color: ${this.link.color_picker};
        --text-color: ${this.link.color_text};
      `;
      },

      linkClass(): Record<string, boolean> {
        const className = 'burger-link';
        const relativeLink = removeBurninghutFromUrl(this.link.link);

        return {
          [`${className}--colored-text`]: Boolean(this.link.color_text),
          [`${className}--colored-bg`]: Boolean(this.link.color_picker),
          [`${className}--active`]: useRoute().path === relativeLink,
        };
      },
    },

    methods: {
      removeBurninghutFromUrl,
    },
  });
</script>
<style lang="scss" scoped>
  @use '../styles/TheHeader.variables.scss' as *;

  // fix styles overriding
  .burger-link.burger-link {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    min-height: $cellHeight;
    line-height: 28px;
    height: 100%;
    width: 100%;
    position: relative;
    padding: 0 48px;

    @include normalText;

    &--active {
      background: #e4fcfb;
    }

    &::before {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      pointer-events: none;
      border-radius: 32px;
      border: 4px solid $hover-color--1;
      transition: opacity 0.3s ease;
    }

    @include hover {
      &:not(.burger-link--colored-text, .burger-link--colored-bg) {
        color: $hover-color--1;
      }

      &::before {
        opacity: 1;
      }
    }

    @include big-tablet {
      padding: 12px 24px;
      font-size: 18px;
    }

    &__title {
      display: block;
      padding: $spacing-1 $spacing-3;
      color: var(--text-color);
      background: var(--bg-color);
      border-radius: 100px;
    }
  }

  .burger-link--colored-bg.burger-link--colored-bg {
    @include big-tablet {
      padding: 0 $spacing-3;
    }
  }
</style>
